import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const contactApi = createApi({
  reducerPath: 'contactApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v2/storefront' }),
  endpoints: (builder) => ({
    sendContact: builder.mutation({
      query: (data) => ({
        url: '/contact',
        method: 'POST',
        body: { contact: data },
      }),
    }),
  }),
});

export const { useSendContactMutation } = contactApi;
